export enum U_TURN_TYPE {
  OCCURRED = 'occurred',
  DID_NOT_OCCUR = 'did_not_occur',
}
